module.exports = __webpack_public_path__ + "static/img/driver_head.d6a8ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/driver_head.png
// module id = LMOF
// module chunks = 1